import React from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { UI_COLORS } from "../styles/clientePortalStyles";

// ==================== ESTILOS ====================

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(8, 2),
    textAlign: "center",
  },
  icon: {
    fontSize: 64,
    color: UI_COLORS.text.disabled,
    marginBottom: theme.spacing(2),
  },
  title: {
    color: UI_COLORS.text.secondary,
    marginBottom: theme.spacing(1),
  },
  description: {
    color: UI_COLORS.text.disabled,
    maxWidth: 400,
  },
  actionContainer: {
    marginTop: theme.spacing(2),
  },
}));

/**
 * Componente EmptyState - Estado vacío con mensaje e icono
 *
 * @param {Component} icon - Icono de Material UI a mostrar
 * @param {string} title - Título del mensaje
 * @param {string} description - Descripción opcional
 * @param {Component} action - Botón o acción opcional (React element)
 *
 * @example Sin acción
 * {facturas.length === 0 && (
 *   <EmptyState
 *     icon={ReceiptOutlined}
 *     title="No tienes facturas pendientes"
 *     description="Todas tus facturas están al día"
 *   />
 * )}
 *
 * @example Con acción
 * {tareas.length === 0 && (
 *   <EmptyState
 *     icon={AssignmentOutlined}
 *     title="No tienes tareas activas"
 *     description="No hay tareas asignadas en este momento"
 *     action={
 *       <Button variant="outlined" color="primary">
 *         Ver historial
 *       </Button>
 *     }
 *   />
 * )}
 */
export default function EmptyState({ icon: Icon, title, description, action }) {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      {/* Icono */}
      {Icon && <Icon className={classes.icon} />}

      {/* Título */}
      <Typography variant="h6" className={classes.title}>
        {title}
      </Typography>

      {/* Descripción */}
      {description && (
        <Typography variant="body2" className={classes.description}>
          {description}
        </Typography>
      )}

      {/* Acción opcional */}
      {action && <Box className={classes.actionContainer}>{action}</Box>}
    </Box>
  );
}
